import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fix4",
  "use": "icon-fix4-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-fix4\"><path d=\"M22 16h2V8h-8v2h6v6z\" fill=\"currentColor\" /><path d=\"M8 24h8v-2h-6v-6H8v8z\" fill=\"currentColor\" /><path d=\"M26 28H6a2.002 2.002 0 0 1-2-2V6a2.002 2.002 0 0 1 2-2h20a2.002 2.002 0 0 1 2 2v20a2.002 2.002 0 0 1-2 2zM6 6v20h20.001L26 6z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol